import { ReactNode } from 'react';
import InfoIcon from '@mui/icons-material/Info';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { SxProps } from '@mui/system/styleFunctionSx';
import { StyledCard } from './styledComponents';

interface Props {
  children: ReactNode;
  sx?: SxProps;
}

export const InfoCard = ({ children, sx }: Props) => {
  const theme = useTheme();

  return (
    <StyledCard sx={{ backgroundColor: 'rgba(0, 184, 217, .12)', ...sx }}>
      <InfoIcon sx={{ color: theme.palette.info.main }} />
      <Box sx={{ '& p': { color: theme.palette.info.dark } }}>{children}</Box>
    </StyledCard>
  );
};
